export function SVG_ShiftY(y, svgElement) {
  var dy = svgElement["dy"];
  if (dy != null) y += dy;

  return y;
}
